module.exports = {
  pathPrefix: "/", // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
  title: "Monstock - Gérez vos stocks en toute mobilité", // Navigation and Site Title
  titleAlt: "Monstock - Gérez vos stocks en toute mobilité", // Title for JSONLD
  description:
    "Logiciel de gestion des stocks et des flux en toute mobilité avec traçabilité complète",
  headline: "headline", // Headline for schema.org JSONLD
  url: `${process.env.URL}`, // Domain of your site. No trailing slash!
  ogLanguage: "en_US", // Facebook Language

  // JSONLD / Manifest
  favicon: "static/images/favicon.png", // Used for manifest favicon generation
  shortName: "Monstock", // shortname for manifest. MUST be shorter than 12 characters
  author: "Monstock", // Author for schemaORGJSONLD
  themeColor: "#fa6400",
  backgroundColor: "#ffffff",
  logo: "/images/logo.jpg",

  twitter: "@monstock_net", // Twitter Username
  facebook: "monstock", // Facebook Site Name
  googleAnalyticsID: "UA-92829588-2",

  gdprMessage: "This website uses cookies to enhance the user experience",
}
